import React from "react";

import { getPrice } from "../../../../util";

import "./index.scss";

const Services = ({ services, dealerLocation, t }) => {
  if (!services?.length) return null;

  const hasPrices = services.some(s => s.price);
  const showIncludingVat = Boolean(dealerLocation?.include_vat);

  return (
    <div className="desk-comm-services">
      <div className="desk-comm-services-header">
        <span className="desk-comm-services-col-title">{t("cc_title").message || "Title"}</span>
        <span className="desk-comm-services-col-remarks">{t("cc_remarks").message || "Remarks"}</span>
        {hasPrices && (
          <span className="desk-comm-services-col-price">
            {showIncludingVat ? t("cc_price_inc_vat").message || "Price (incl. VAT)" : t("cc_price_excl_vat").message || "Price (excl. VAT)"}
          </span>
        )}
      </div>

      <div className="desk-comm-services-body">
        {services.map((service, index) => (
          <div className="desk-comm-service" key={index}>
            <span className="desk-comm-service-title">{service.title}</span>
            <span className="desk-comm-service-remark">{service.mechanic_notes || ""}</span>
            {hasPrices && <span className="desk-comm-service-price">{getPrice(service.price, dealerLocation)} €</span>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
